import { Switch, useRouteMatch } from 'react-router-dom';
import { DialogRoute } from 'components/dialog-route';
import * as NavMenu from 'components/nav-menu';
import { CampaignSharingGeneralSettings } from 'components/pages/campaign-settings/campaign-sharing/general';
import { Widgets } from 'components/pages/campaign-settings/campaign-sharing/widgets';
import { WidgetComponentForm } from 'components/pages/campaign-settings/campaign-sharing/widgets/WidgetComponentForm';
import { Route } from 'components/router/Route';
import { WidgetEmbedDialog } from 'components/widgets/WidgetEmbedDialog';
import { useFlags } from 'launchdarkly-react-client-sdk';

const CampaignSharingRoutes = {
    General: 'general',
    Widgets: 'widgets',
};

const CampaignSharingRouter = () => {
    const match = useRouteMatch();
    const { campaignWidgets } = useFlags();

    return (
        <div className={'grid grid-cols-10 gap-4'}>
            <NavMenu.Root
                aria-label="Sharing"
                className="col-span-full lg:col-span-2"
                orientation="vertical"
            >
                <NavMenu.Item exact={true} to={`${match.url}`}>
                    General
                </NavMenu.Item>
                {!campaignWidgets && (
                    <NavMenu.Item to={`${match.url}/${CampaignSharingRoutes.Widgets}`}>
                        Widgets
                    </NavMenu.Item>
                )}
            </NavMenu.Root>
            <div className={`col-span-full lg:col-span-8`}>
                <Switch>
                    <Route
                        exact={true}
                        path={match.path}
                        component={CampaignSharingGeneralSettings}
                    />
                    <Route path={`${match.path}/${CampaignSharingRoutes.Widgets}`}>
                        {({ match }) => (
                            <>
                                <DialogRoute
                                    path={`${match?.path}/:widgetId/embed`}
                                    component={WidgetEmbedDialog}
                                />
                                <Switch>
                                    <Route path={`${match?.path}/:widgetId`}>
                                        {({ match }) => (
                                            <Switch>
                                                <Route
                                                    path={`${match?.path}/config`}
                                                    component={WidgetComponentForm}
                                                />
                                                <Route path={match?.path} component={Widgets} />
                                            </Switch>
                                        )}
                                    </Route>
                                    <Route path={match?.path} component={Widgets} />
                                </Switch>
                            </>
                        )}
                    </Route>
                </Switch>
            </div>
        </div>
    );
};

export { CampaignSharingRouter };
